// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2oOg8","consentsList":"PatientConsents_consentsList__1UcUJ","consentsListEmpty":"PatientConsents_consentsListEmpty__1eorg"};